<template>
    <div class="d-flex flex-row flex-wrap justify-content-center">
        <b-button
            :id="`btn-values-${evaluationStatus}`"
            variant="link"
            class="nav-item"
            :key="evaluationStatus"
            v-b-tooltip.hover="option.tooltip"
            :pressed="model == evaluationStatus"
            v-for="(option, evaluationStatus) in options"
            @click="onChange(evaluationStatus)"
        >
            <span style="font-size: 15px" class="mr-2">{{ option.title }}</span>
            <b-badge
                pill
                v-if="option.badge !== undefined && option.badge.count > 0"
                :variant="option.badge.variant"
            >
                {{ option.badge.count }}
            </b-badge>
        </b-button>
    </div>
</template>
<script>
import i18n from '@/i18n'

export default {
    props: {
        model: {
            type: String,
            required: true,
        },
        amounts: {
            type: Object,
            required: false,
        },
    },
    data() {
        return {}
    },
    methods: {
        onChange(status) {
            this.$emit('update:model', status)
            this.$emit('change', status)
        },
    },
    computed: {
        options() {
            return {
                pending: {
                    title: i18n.t('values.evaluationStatuses.pending'),
                    badge: {
                        count: this.amounts.pending,
                        variant: 'danger',
                    },
                },
                sent: {
                    title: i18n.t('values.evaluationStatuses.sent'),
                    badge: {
                        count: this.amounts.editing,
                        variant: 'warning',
                    },
                    tooltip:
                        this.amounts.editing > 0
                            ? i18n.t('values.editingEvaluations')
                            : null,
                },
                declined: {
                    title: i18n.t('values.evaluationStatuses.declined'),
                },
                closed: {
                    title: i18n.t('values.evaluationStatuses.closed'),
                },
            }
        },
    },
}
</script>
<style lang="sass" scoped>
$primary-color: #20a8d8
$border-bottom: 2px solid $primary-color

.badge
    padding-left: 8px
    padding-right: 8px

.badge-warning
    color: #ffff
    background-color: #ffc107

.nav-item
    color: #808080
    font-weight: 600
    text-decoration: none
    border: 2px solid transparent

.active,
.nav-item:hover,
.nav-item:focus,
.nav-item:active
    color: $primary-color
    border-bottom: $border-bottom

.nav-item:disabled
    cursor: progress !important
</style>
